import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

@Injectable()
export class ApiService {
  constructor(private http: Http) { }

  getPeople() {
    return this.http.get('/data/people.json')
      .map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/api.service.ts